<div class="page-header">
    <div class="background">
        <video #forestVideo loop muted autoplay playsinline preload="auto" data-wf-ignore="true" data-object-fit="cover">
            <source type="video/mp4" src="https://d2z7yiz3wla4oq.cloudfront.net/videos/video-reforestaction.mp4" data-wf-ignore="true">
        </video>
    </div>
    <div class="main-content">
        <div>
            <div class="logos-line">
                <img class="item-left" src="assets/images/reforestaction/reforestaction-logo.svg" />
                <img class="item-center" src="assets/images/reforestaction/cross.svg" />
                <img class="item-right" src="assets/images/reforestaction/kinomap-logo.svg" />
            </div>
            <div class="title">
                {{ 'events.reforestaction.header.title.l1' | translate }}
                <br>
                {{ 'events.reforestaction.header.title.l2' | translate }}
            </div>
            <div *ngIf="active && total" class="label" style=" gap: .5em; margin-top: .5em; font-size: 26px;">
                {{ 'events.reforestaction.header.details.from' | translate }}
                <strong style="font-size: 36px;">{{ startDate | date: 'mediumDate' : '' : translateService.get() }}</strong>
                {{ 'events.reforestaction.header.details.to' | translate }}
                <strong style="font-size: 36px;">{{ endDate | date: 'mediumDate' : '' : translateService.get() }}</strong>
            </div>
            <div class="detail-rectangles">
                <div class="blur">
                    <div class="main-info">100 km</div>
                    <div class="details-info">{{ 'events.reforestaction.header.details.travelled' | translate }}</div>
                </div>
                <div class="equal"><img src="assets/images/reforestaction/equal.svg" /></div>
                <div class="blur">
                    <div class="main-info">{{ 'events.reforestaction.header.details.one-tree' | translate }}</div>
                    <div class="details-info">{{ 'events.reforestaction.header.details.planted' | translate }}</div>
                </div>
            </div>
        </div>

    </div>

    <div class="details-section">
        <div class="section-container">

            <div  *ngIf="startDate && endDate" class="section-content">
                <div class="label-line">

                    <img *ngIf="total === 0" src="assets/images/reforestaction/calendar.svg" />
                    <div class="label">
                        <!-- <app-progress-bar *ngIf="total && total !== 0" [completion]="total | toTree"></app-progress-bar> -->
                        <div *ngIf="!active || total === 0">
                            {{ 'events.reforestaction.header.details.from' | translate }}
                            <strong>{{ startDate | date: 'mediumDate' : '' : translateService.get() }}</strong>
                            {{ 'events.reforestaction.header.details.to' | translate }}
                            <strong>{{ endDate | date: 'mediumDate' : '' : translateService.get() }}</strong>
                        </div>
                        <div *ngIf="total">
                            <strong *ngIf="(total | toTree) === 1">{{ total | toTree }} {{ 'events.reforestaction.tree-1-single.one' | translate }}</strong>
                            <strong *ngIf="(total | toTree) > 1">{{ total | toTree }} {{ 'events.reforestaction.tree-1-single.other' | translate }}</strong>
                            {{ 'events.reforestaction.tree-2' | translate }}
                        </div>

                    </div>
                </div>

                <button (click)="subMe.emit()" *ngIf="active && !isSubscribed" class="btn-primary">{{ 'events.reforestaction.general.i-contribute' | translate }}</button>
                <button *ngIf="!active" class="btn-primary" disabled>{{ 'events.reforestaction.event-ended' | translate }}</button>
                <button *ngIf="active && isSubscribed" class="btn-primary" disabled>{{ 'events.reforestaction.subscribedBtn' | translate }}</button>
            </div>
        </div>
    </div>

    <div class="devices" #devices>
        <img src="assets/images/reforest.png" />
    </div>
</div>
